import Eastern71 from '../Eastern/Grand Eastern 7 (1).webp'
import Eastern72 from '../Eastern/Grand Eastern 7 (2).webp'


const Eastern7images =[
Eastern71,Eastern72
]

export default Eastern7images;